import {app} from "../../../../../../app";

class UserSettingsService {

    /** @ngInject */
    constructor($http) {
        this.$http = $http;
    }
    getAdminSettings(companyId) {
        const url = `app/rest/v2/company/${companyId}/administratorsettings`;
        return this.$http.get(url).then(({data}) => data);
    }

    setAdminSettings(companyId, profile) {
        const url = `app/rest/v2/company/${companyId}/administratorsettings`;
        return this.$http.put(url, profile ).then(({data}) => data);
    }

    applyDisplayNameChanges(companyId, typeName) {
        const url = `app/rest/v2/company/${companyId}/administratorsettings/setdisplaynames`;
        const params = {type: typeName};
        return this.$http.post(url, null, {params}).then(({data}) => data);
    }
}

app.service('UserSettingsService', UserSettingsService);


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/all-users/user-settings/user-settings.service.js